export const getOpportunitiesYears = (currentYear: number) => {
  if (!currentYear) {
    return [2022, 2023]
  }
  const lastYear = currentYear - 1

  return [lastYear, currentYear]
}
